import * as requestFromServer from "./SchoolProfileCrud";
import { schoolProfileSlice } from "./SchoolProfileSlice";

const {actions} = schoolProfileSlice;

export const getSchoolProfile = () => async dispatch => {
  dispatch(actions.startCall());  
  return requestFromServer
    .getSchoolProfile()
    .then(response => {
      dispatch(actions.schoolProfileFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveSchoolProfile = schoolProfile => async dispatch => {
  dispatch(actions.startCall());
  return requestFromServer
    .saveSchoolProfile(schoolProfile)
    .then(response => {
      dispatch(actions.schoolProfileSaved());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const cleanSchoolProfileState = () => dispatch => {
  dispatch(actions.schoolProfileStateCleaned());
}